/* src/hooks/useDebounce.js */

import { useState, useEffect } from 'react';

// Хук debounce для задержки обновления значения
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(handler); // Очистка таймаута при изменении value или unmount
  }, [value, delay]);

  return debouncedValue;
}
